import { render, staticRenderFns } from "./DaftarLaporanPemilikSistem.vue?vue&type=template&id=07d7c077&scoped=true&"
import script from "./DaftarLaporanPemilikSistem.vue?vue&type=script&lang=js&"
export * from "./DaftarLaporanPemilikSistem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d7c077",
  null
  
)

export default component.exports